module.exports = __webpack_public_path__ + "img/cultura-viva.600f76ca.png";